import { DateSelectionComponent, NeoReport, Report } from "@singularsystems/neo-reporting";
import ShareCapitalCriteria from "./ShareCapitalCriteria";
import { ReportCategory } from "../ReportCategory";
import { Neo } from "@singularsystems/neo-react";

@NeoReport("ShareCapitalReport", { category: ReportCategory.CombinedReports })
export default class ShareCapitalReport extends Report<ShareCapitalCriteria> {

    constructor() {
        super(ShareCapitalCriteria);
    }

    public renderCriteria() {
        return <div>
            <DateSelectionComponent criteria={this.criteria} />
            <Neo.FormGroupInline bind={this.criteria.meta.showLinkedOnly} />
            <Neo.FormGroupInline bind={this.criteria.meta.showRedeemed} />
        </div>;
    }
}